/* Cobify · Selector de sets (kits) para el bloque de packs.
   Al elegir un set, todas las unidades del pack pasan a ese set y se recalculan los precios. */
(function () {
  'use strict';

  function apply(packs, input) {
    if (!packs || !packs.units || typeof packs.refreshPrices !== 'function') return false;
    var name = input.value;
    packs.units.forEach(function (u) {
      u.color = name;
      u.battery = false;
    });
    packs.renderUnits();
    packs.refreshPrices();
    var img = input.dataset.image;
    if (img) {
      packs.querySelectorAll('.cobify-pack__thumbs img').forEach(function (i) {
        i.removeAttribute('srcset');
        i.removeAttribute('sizes');
        i.src = img;
      });
    }
    return true;
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('[data-cobify-kit]')) return;
    apply(input.closest('cobify-packs'), input);
  });

  function init() {
    document.querySelectorAll('cobify-packs [data-cobify-kit]:checked').forEach(function (i) {
      apply(i.closest('cobify-packs'), i);
    });
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cobify-packs').then(function () { setTimeout(init, 0); });
  } else {
    window.addEventListener('load', init);
  }
})();
